module.exports = __webpack_public_path__ + "img/325.f687ac52.jpg";